import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import EmployerReview from "../components/EmployerReview";
import * as projectActions from "../../../../actions/project.actions";

class EmployerReviewContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: null,
      checkedReviewer: false
    };

    this.submitEmployerReview = this.submitEmployerReview.bind(this);

    this.props.projectActions.getProject(this.props.match.params.projectId);
  }

  componentDidUpdate() {
    const employerId = _.get(this.props.project, "data.data.user_id");

    if (!this.state.checkedReviewer && employerId) {
      this.setState({ checkedReviewer: true });
      this.props.projectActions.checkReviewer(
        this.props.match.params.projectId,
        employerId
      );
    }
  }

  getMappedAnswers(data) {
    const answers = [];

    _.forEach(data, (answer, index) => {
      const questionId = _.toInteger(index);

      if (answer && questionId) {
        answers.push({
          question_id: questionId,
          value: answer
        });
      }
    });

    return answers;
  }

  getMappedContacts(emails, names) {
    const contacts = [];

    _.forEach(emails, (email, questionId) => {
      if (email && questionId) {
        contacts.push({
          email: email,
          name: names[questionId] || "not filled"
        });
      }
    });

    return contacts;
  }

  submitEmployerReview(data) {
    const payload = {
      project_id: this.props.match.params.projectId,
      target_id: _.get(this.props.project, "data.data.user_id"),
      answers: this.getMappedAnswers(data),
      contacts: this.getMappedContacts(data.emails, data.names)
    };

    this.props.projectActions.storeReview(payload, "/member/projects/matches");
  }

  render() {
    const project = _.get(this.props.project, "data.data");
    const employerName = _.get(project, "user.profile.company.name");

    return (
      <EmployerReview
        onSubmit={this.submitEmployerReview}
        employerName={employerName}
        sections={this.props.project.reviewQuestionsForMembers}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployerReviewContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/employerReview/containers/EmployerReviewContainer.js